// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-song {
    background-color: thistle;
    padding: 20px;
}
.new-song h2 {
    margin: 0 0 0.5em 0;
}
.new-song .engine-list {
    margin-bottom: 0.5em;
}
`, "",{"version":3,"sources":["webpack://./src/ui/views/new_song.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,oBAAoB;AACxB","sourcesContent":[".new-song {\n    background-color: thistle;\n    padding: 20px;\n}\n.new-song h2 {\n    margin: 0 0 0.5em 0;\n}\n.new-song .engine-list {\n    margin-bottom: 0.5em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
